import { createGlobalStyle } from 'styled-components';
import { fonts } from './fonts';

export const GlobalStyles = createGlobalStyle`
    ${fonts}

    * {
        box-sizing: border-box;
    }

    html, body {
        width: 100%;
    }

    body {
        font-family: 'Geograph-Regular', sans-serif;
        margin: 0;
        padding: 0;
        font-size: 16px;
        background: ${({ theme }) => theme?.bodyBackground};

        &.fixed {
            position: fixed;
            overflow: hidden;
        }
    }

    h1, h2, h3, h4, h5, h6 {
        font-family: 'DomaineDispCondRegular', sans-serif;
    }

    p {
        &.ingress {
            font-family: 'DomaineText-Regular', 'Times New Roman', serif;
            font-size: 1.1em;
        }
    }

    input, textarea, button, a {
        font-family: 'Geograph-Regular', sans-serif;
    }
    
`;
